import { Navigate, useLocation } from "react-router-dom";
import { buildLoginUrlWithReturn } from "../utils/helpers/auth/returnUrl";

/**
 * The publicRoutes catch-all. A guest has no private routes registered (see NavRoutes),
 * so every private path falls through to here — this is the one place that knows where
 * the visitor was actually trying to go, and it preserves it as a `returnUrl` for
 * useAccount.login() to consume.
 *
 * `replace` matters: a push would leave the deep link in history, so Back from the login
 * page would return to it and immediately bounce to login again.
 */
const RedirectToLogin = () => {
  const location = useLocation();

  return <Navigate to={buildLoginUrlWithReturn(location)} replace />;
};

export default RedirectToLogin;
